import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-02/lesson-10/task-01";

const task: Slide = {
  title: `Which of the following are crucial to the calculation of sharpness?`,
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
